import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DataTableColumn, DataTableComponent } from '@shared/components/data-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyResponse } from '../../company.model';
import { ActionMenu } from "@shared/components/action-menu/action-menu";
import { useCompanyActionMenu } from "./company-action-menu-composable";

@Component({
  selector: 'company-table',
  imports: [DataTableComponent, ActionMenu, ...SharedMaterialUIModule],
  templateUrl: './company-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CompanyTableComponent {
  protected readonly columns: DataTableColumn<CompanyResponse>[] = [
    {
      id: 'name',
      header: 'Name',
      value: (company) => company.name,
      cellClass: 'px-3 py-3 font-medium',
    },
    {
      id: 'status',
      header: 'Status',
      value: (company) => (company.isActive ? 'Active' : 'Inactive'),
      cellClass: 'px-3 py-3',
    },
  ];

  readonly companies = input<CompanyResponse[]>([]);
  readonly loading = input(false);

  readonly canDeactivate = input(false);
  readonly canActivate = input(false);
  readonly canUpdate = input(false);

  readonly actionCompanyId = input<string | null>(null);

  readonly toggled = output<CompanyResponse>();
  readonly actionMenuItems = useCompanyActionMenu().companyActionMenuItems;
  readonly actions: Record<string, any> = {
    'toggled': this.toggled,
  };
}